<template>
  <div>
    <div v-if="athState" class="addhGuide" :style="`top:${navH+11}px`" >
      <img src="@/assets/fdts.png"
              class="addHTri"
              alt="">
      <div class="addHCont" >
        <div class="addtitView">
          <span class="addHText">支持添加桌面啦，点击 </span>
          <img src="@/assets/addhome.png"
              class="addHhome"
              alt="">
          <span class="addHText"> 设置</span>
        </div>
        <img src="@/assets/addtohtop.png"
              class="showaddImage"
              alt="">
      </div>
      <div class="addHSep" ></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.addhGuide{
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    right: 20px;
    top: 188px;
    z-index: 9999999;
  }
  .addHTri{
    position: absolute;
    opacity: 0.8;
    width: 42px;
    height: 21px;
    right: 20px;
    top: -20px;
  }
  .addHSep{
    height: 25px;
  }
  .addHCont{
    flex-direction: column;
    opacity: 0.96;
    background: #34374A;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .addHText{
    font-size: 30px;
    opacity: 0.96;
    color: #ffffff;
  }
  .addHhome{
    margin-bottom: -4px;
    width: 28px;
    height: 28px;
  }
  .showaddImage{
    width: 240px;
    height: 240px;
    margin-bottom: 20px;
  }
  .addtitView{
    flex-direction: row;
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 20px;
  }
</style>

<script>

import Util from '@/base/Util';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  components: {},
  data() {
    return {
      athState: false,
      navH: 0,
    };
  },
  computed: {
  },
  created() {
    this.navH = StoreManger.getNAVSTATEHEIGHT();
  },
  mounted() {
    this.showHiddenTip();
  },
  methods: {
    showHiddenTip() {
      let needshow = false;
      needshow = false;
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      if (systemInfo) {
        if (systemInfo.version) {
          if (systemInfo.version >= '6.4.9') {
            needshow = true;
          }
        }
      }
      // #endif
      if (needshow) {
        if ((this.getCache('add-to-home-tip-guide') === '1')) {
          this.athState = false;
        } else {
          this.athState = true;
          setTimeout(this.setcloseTip, 3000);
        }
      }
    },
    setcloseTip() {
      this.athState = false;
      this.setCache('add-to-home-tip-guide', '1');
    },
    setCache(key, value) {
      Util.setTipGuideCache(key, value);
    },
    getCache(key) {
      return Util.getTipGuideCache(key);
    },
  },
};
</script>
